var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00639A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.43 20.98C27.47 20.66 27.5 20.34 27.5 20C27.5 19.66 27.47 19.34 27.43 19.02L29.54 17.37C29.73 17.22 29.78 16.95 29.66 16.73L27.66 13.27C27.54 13.05 27.27 12.97 27.05 13.05L24.56 14.05C24.04 13.65 23.48 13.32 22.87 13.07L22.49 10.42C22.46 10.18 22.25 10 22 10H18C17.75 10 17.54 10.18 17.51 10.42L17.13 13.07C16.52 13.32 15.96 13.66 15.44 14.05L12.95 13.05C12.72 12.96 12.46 13.05 12.34 13.27L10.34 16.73C10.21 16.95 10.27 17.22 10.46 17.37L12.57 19.02C12.53 19.34 12.5 19.67 12.5 20C12.5 20.33 12.53 20.66 12.57 20.98L10.46 22.63C10.27 22.78 10.22 23.05 10.34 23.27L12.34 26.73C12.46 26.95 12.73 27.03 12.95 26.95L15.44 25.95C15.96 26.35 16.52 26.68 17.13 26.93L17.51 29.58C17.54 29.82 17.75 30 18 30H22C22.25 30 22.46 29.82 22.49 29.58L22.87 26.93C23.48 26.68 24.04 26.34 24.56 25.95L27.05 26.95C27.28 27.04 27.54 26.95 27.66 26.73L29.66 23.27C29.78 23.05 29.73 22.78 29.54 22.63L27.43 20.98ZM20 23.5C18.07 23.5 16.5 21.93 16.5 20C16.5 18.07 18.07 16.5 20 16.5C21.93 16.5 23.5 18.07 23.5 20C23.5 21.93 21.93 23.5 20 23.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.77be2763967222b5f508066a87a8977a.svg";
export { ForwardRef as ReactComponent };